import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IFlashQuoteItem } from '@App/types';
import { RootState } from '@App/store';

import flashQuotesApi from '@App/services/flashQuotes/flashQuotesApi';
import { pollingSucceeded, pollingFailed } from '@Features/errorHandler/polling/pollingErrorHandlerSlice';

import { pollingErrorHandlerSlice } from '@Features/errorHandler/polling/pollingErrorHandlerSlice';

export interface IRecordListState {
  changeTimestamp: number; // Tohle trigeruje mount/unmout pooling kontejneru, tak aby se forsnul reload při znovu kliku (jinak se vysypal state)
  dataLoaded: boolean;
  isFetching: boolean;
  error: any;
  data: IFlashQuoteItem[];
}

const initialState: IRecordListState = {
  changeTimestamp: 0,
  dataLoaded: false,
  isFetching: false,
  error: null,
  data: [],
};

export const getFlashQuotesDataAsync = createAsyncThunk(
  'flashQuotes/fetchData',
  async (_, { dispatch, rejectWithValue, signal }) => {
    try {
      const response = await flashQuotesApi.fetchFlashQuotesData(signal);

      dispatch(pollingSucceeded());

      return response;
    } catch (err) {
      dispatch(pollingFailed({ sectionName: 'FlashQuotes', error: err }));
      return rejectWithValue(err);
    }
  }
);

export const flashQuotesSlice = createSlice({
  name: 'flashQuotesSlice',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFlashQuotesDataAsync.pending, state => {
        state.isFetching = true;
      })
      .addCase(getFlashQuotesDataAsync.fulfilled, (state, action) => {
        state.isFetching = false;
        state.dataLoaded = true;
        state.data = action.payload;
      })
      .addCase(getFlashQuotesDataAsync.rejected, (state, action) => {
        if (action.error.name !== 'AbortError') {
          state.isFetching = false;
          state.error = action.payload;
        }
      })
      .addCase(pollingErrorHandlerSlice.actions.clearPollingErrors, (state) => {
        state.error = null;
      });
  }
});

export const selectIsFetching = (state: RootState) => state.flashQuotes.isFetching;
export const selectError = (state: RootState) => state.flashQuotes.error;
export const selectDataLoaded = (state: RootState) => state.flashQuotes.dataLoaded;
export const selectData = (state: RootState) => state.flashQuotes.data;
export const selectChangeTimestamp = (state: RootState) => state.flashQuotes.changeTimestamp;

export default flashQuotesSlice.reducer;